import { render, staticRenderFns } from "./horizontal-topbar.vue?vue&type=template&id=0967dbc6&scoped=true"
import script from "./horizontal-topbar.vue?vue&type=script&lang=ts"
export * from "./horizontal-topbar.vue?vue&type=script&lang=ts"
import style0 from "./horizontal-topbar.vue?vue&type=style&index=0&id=0967dbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967dbc6",
  null
  
)

export default component.exports